import React, { Component } from 'react';
import Label from '../../../../components/atoms/Label';
import LabelWithText from '../../../../components/molecules/LabelWithText';
import LabelWithBtn from '../../../../components/molecules/LabelWithBtn';
import curencyFormat from '../../../../utils/helpers/curencyFormat';
import dateFormatIndo from '../../../../utils/helpers/dateFormatIndo';

export default ({ title, dataDetail }) => {
  let col = { label : 'col-md-3', text : 'col-md-9' }
  let { loanAmount, loanInterest, loanPenalty, loanDiscount } = dataDetail
  let total = Number(loanAmount) + Number(loanInterest) + Number(loanPenalty) - Number(loanDiscount)
  console.log({ dataDetail })
  return(
    <div>
        <Label value={title} className='label-menu'/>
        <div>
          <LabelWithText label = {'Pokok'} text = {loanAmount ? `Rp ${curencyFormat(loanAmount)}` : '-'} col={col} />
          <LabelWithText label = {'Bunga'} text = {loanInterest ? `Rp ${curencyFormat(loanInterest)}` : '-'} col={col} />
          <LabelWithText label = {'Denda'} text = {loanPenalty ? `Rp ${curencyFormat(loanPenalty)}` : '-'} col={col} />
          <LabelWithText label = {'Diskon'} text = {loanDiscount ? `(-Rp ${curencyFormat(loanDiscount)})` : '-'} col={col} />
          <LabelWithText label = {'Total'} textbold colorText={'color-blue'} text = {total ? `Rp ${curencyFormat(total)}` : '-'} col={col} />
        </div>
    </div>
  )
}